import { Injectable } from '@angular/core';
import { Notifications } from '@mobiscroll/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastNotificationService {

  constructor(public notify: Notifications) { }

   /**
   * Zeigt eine Erfolgs-Toast-Nachricht an.
   * Wird für positive Bestätigungen im UI verwendet.
   */
  successToast(message: any): void {
    this.notify.toast({
      message: `${message}`,
      color: 'success',
    });
  }

    /**
   * Zeigt eine Fehler-Toast-Nachricht an.
   * Wird bei kritischen Fehlern oder fehlgeschlagenen Aktionen genutzt.
   */
  dangerToast(message: any): void {
    this.notify.toast({
      message: `${message}`,
      color: 'danger',
    });
  }

  /**
   * Zeigt eine Warn-Toast-Nachricht an.
   * Wird für Hinweise oder potenziell problematische Aktionen genutzt.
   */
  warningToast(message : any): void {
    this.notify.toast({
      message: `${message}`,
      color: 'warning',
    });
  }

    /**
   * Zeigt ein modales Alert-Fenster mit Titel und Nachricht an.
   * Wird für wichtige Hinweise oder Bestätigungen verwendet.
   */
  alertToast(title: string, message : string): void {
    this.notify.alert({
      title: `${title}`,
      message: `${message}`
    });
  }


}
